import { ApiGufGufsListRequest, GUF } from "@nens/brostar/openapi-client";
import {
  gufDeliveryContextOptions,
  legalTypeOptions,
  qualityRegimeOptionsType,
} from "@nens/brostar/uploadapi-client";

import { SearchOption } from "@/components/searchbox";

export const gufInformation: SearchOption<keyof GUF, keyof ApiGufGufsListRequest>[] = [
  { key: "broId", searchKey: "broIdIcontains", label: "BRO-ID" },
  { key: "internalId", label: "Interne naam" },
  {
    key: "qualityRegime",
    label: "Kwaliteitsregime",
    enum: qualityRegimeOptionsType.map((option) => ({ key: option, label: option })),
  },
  {
    key: "deliveryContext",
    label: "Kader aanlevering",
    enum: gufDeliveryContextOptions.map((option) => ({ key: option.value, label: option.label })),
  },
  {
    key: "legalType",
    label: "Rechtstype",
    enum: legalTypeOptions.map((option) => ({ key: option.value, label: option.label })),
  },
  { key: "startTime", label: "Starttijd" },
  { key: "endTime", label: "Eindtijd" },
];
